module.exports = __webpack_public_path__ + "img/1.f42397a1.svg";